import { cn } from '@/platform/lib/utils';

const Line = () => <div className='h-px flex-1 bg-gray-200' />;

const Divider = ({ content, className, ...props }) => (
    <div className={cn('flex items-center gap-4', className)} {...props}>
        <Line />
        {content && (
            <span className='text-xs font-semibold tracking-wider text-gray-700 uppercase'>
                {content}
            </span>
        )}
        {content && <Line />}
    </div>
);

export default Divider;
